import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MessageService } from 'primeng/components/common/messageservice';
import { FuncoesClienteService } from '../../commons/servicos/funcoes-cliente.service';
import { UnidadePolicialService } from '../../commons/servicos/unidade-policial.service';
import { AtendimentoService } from '../atendimento/atendimento.service';
import { ConsultaUnificadaModule } from '../consulta-unificada/consulta-unificada.module';
import { RotasInternasModule } from '../rotas-internas/rotas-internas.module';
import { SupervisaoModule } from '../supervisao/supervisao.module';
import { UilibModule } from '../uilib/uilib.module';
import { HomeComponent } from './ui/home/home.component';
import { WelcomeComponent } from './ui/welcome/welcome.component';
import { ContatoDeEstabelecimentoService } from '../portal/telas/contato-de-estabelecimento/contato-de-estabelecimento.service';


@NgModule({
  declarations: [
    HomeComponent,
    WelcomeComponent
  ],
  imports: [
    CommonModule, UilibModule, RotasInternasModule, ConsultaUnificadaModule, SupervisaoModule
  ],
  exports: [],
  providers: [ FuncoesClienteService, MessageService, AtendimentoService,
  UnidadePolicialService ]
})
export class PrincipalModule { }



// WEBPACK FOOTER //
// ./src/app/modulos/principal/principal.module.ts